import type { WeeklyReport, WeeklyReportItem } from './types'

function validateItems(label: string, items: WeeklyReportItem[]) {
  const errors: string[] = []
  if (items.length > 10) errors.push(`${label} 最多 10 項。`)
  items.forEach((item,index)=>{
    if (!item.project.trim()) errors.push(`${label} 第 ${index+1} 項缺少 Project。`)
    else if (item.project.trim().length > 120) errors.push(`${label} 第 ${index+1} 項的 Project 超過 120 字。`)
    if (!item.text.trim()) errors.push(`${label} 第 ${index+1} 項缺少內容。`)
    else if (item.text.trim().length > 500) errors.push(`${label} 第 ${index+1} 項內容超過 500 字。`)
  })
  return errors
}

export function validateWeeklyReport(report: WeeklyReport) {
  const errors = [
    ...validateItems('Weekly Progress',report.weeklyItems),
    ...validateItems('Next Week',report.nextWeekItems),
  ]
  if (!/^\d{4}-\d{2}-\d{2}$/.test(report.reportDate)) errors.push('報告日期格式不正確。')
  if (report.majorIssue.length > 1200) errors.push('Major Issue 超過 1200 字。')
  if (report.nextTest.length > 1200) errors.push('Test 超過 1200 字。')
  return errors
}
